import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment, Box } from '@mui/material';
import { AppsOutlined } from '@mui/icons-material';
import { useCustomApplicationEditor } from '../../../../hooks/useCustomApplicationEditor';
import { useGetApplicationTypesQuery } from '../../../../../../services/DimensionService/dimensionApi';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const ApplicationTypeEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useCustomApplicationEditor(mode);
  const { data: applicationTypes = [], isLoading } = useGetApplicationTypesQuery();
  const labelId = `${mode}-application-type-label`;

  const handleChange = (value: string) => {
    updateRequest({ application: value });
  };

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth required>
        <InputLabel id={labelId}>Application</InputLabel>
        <Select
          labelId={labelId}
          value={request?.application || ''}
          onChange={(e) => handleChange(e.target.value)}
          label="Application"
          disabled={isLoading}
          startAdornment={
            <InputAdornment position="start">
              <AppsOutlined sx={{ color: '#64748b', fontSize: 18 }} />
            </InputAdornment>
          }
        >
          {applicationTypes.map((app) => (
            <MenuItem key={app.value} value={app.value}>
              {app.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ApplicationTypeEditor;
